import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from 'vant/es/locale/lang/en-US';// 引入vant英文语言包
import zhCN from 'vant/es/locale/lang/zh-CN';// 引入vant语言包
import enLocale from './en'
import zhLocale from './zh'
import { Locale } from 'vant';
// const zh = Locale.use('CHN', zhCN);
// const en = Locale.use('ENG', enUS);
// Locale.use('en-US', enUS);
Vue.use(VueI18n)
const messages = {
    CHN: {
        ...zhLocale,
        ...zhCN,
        // zh,
    },
    ENG: {
        ...enLocale,
        ...enUS,
        // en,
    },
    
}


// 更新vant组件库本身的语言变化，支持国际化
// function vantLocales (lang) {
//     if (lang === 'ENG') {
//       Locale.use(lang, enUS)
//     } else if (lang === 'CHN') {
//       Locale.use(lang, zhCN)
//     }
//   }
//   const cunt = vantLocales();
//   Locale.use(messages, messages);
// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
    locale: 'CHN',
    messages,
//   silentTranslationWarn: true//是否隐藏警告
    // messages: {
    //     CHN: require('./zh'),
    //     ENG: require('./en')
    //     // Object.assign()
    // },
    // messages: {
    //     ENG: {
    //       message: {
    //         login: 'hello world',
    //         greeting: 'good morning'
    //       }
    //     },
    //     CHN: {
    //       message: {
    //         login: 'こんにちは、世界',
    //         greeting: 'おはようございます'
    //       }
    //     }
    //   }
})
export default i18n